import { createFileRoute } from "@tanstack/react-router";
import { MerchPromosView } from "../../components/merch/promos-view";
import { listSearch } from "../../lib/list-page/list-search";

/** Merchandising › Promotions: offset pages in the URL. */
export const Route = createFileRoute("/_app/merchandising/promos")({
	validateSearch: listSearch(["code"] as const),
	component: PromosPage,
});

function PromosPage() {
	return <MerchPromosView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
